import { SchemaGroupField } from '../api/schema';
import { parseLayout } from './fieldGroups';
import {
    FieldGroupDraftBody,
    FieldGroupEditorState,
    newFieldGroupEditor,
} from '../components/schema/FieldGroupEditorModal';

// 套件 newDicts 草稿项的纯逻辑 (2026-09-29, 设备 / 材料向导共用).

/** upsertBy 按业务键增改: 已有则原位替换 (编辑不挪位置), 没有则追加. */
export function upsertBy<T>(
    list: T[] | undefined,
    item: T,
    key: (x: T) => string,
): T[] {
    const cur = list || [];
    const k = key(item);
    const idx = cur.findIndex((x) => key(x) === k);
    if (idx < 0) return [...cur, item];
    const out = [...cur];
    out[idx] = item;
    return out;
}

/** parseGroupFields 字段组 fields JSON 串 → 字段数组 (坏 JSON 当空, 让预检去报). */
export function parseGroupFields(fields: string): SchemaGroupField[] {
    try {
        const v = JSON.parse(fields);
        return Array.isArray(v) ? (v as SchemaGroupField[]) : [];
    } catch {
        return [];
    }
}

/** 草稿字段组的公共形态 (设备 / 理化组各自多出的是归属绑定: deviceKeys / cat2Keys). */
export interface DraftGroupBase {
    groupKey: string;
    label: string;
    src?: string;
    fields: string;
    isEnabled?: boolean;
    layout?: string;
    rowSource?: string;
    rowLabel?: string;
    /** 组内 页签 → 分组 结构 JSON 串 (仅设备组; 编辑器分组时才有) */
    fieldLayout?: string;
}

/** draftGroupItem 编辑器请求体 → 草稿项的公共字段 (flat 布局不带矩阵三件套). */
export function draftGroupItem(body: FieldGroupDraftBody): DraftGroupBase {
    return {
        groupKey: body.groupKey,
        label: body.label,
        fields: body.fields,
        isEnabled: body.isEnabled,
        ...(body.src ? { src: body.src } : {}),
        ...(body.fieldLayout ? { fieldLayout: body.fieldLayout } : {}),
        ...(body.layout && body.layout !== 'flat'
            ? {
                  layout: body.layout,
                  rowSource: body.rowSource,
                  rowLabel: body.rowLabel,
              }
            : {}),
    };
}

/** editorFromDraftGroup 草稿组回填编辑器 (仍是新建态: 业务键可改, 保存时按新键覆盖). */
export function editorFromDraftGroup(
    s: DraftGroupBase & { deviceKeys?: string[]; cat2Keys?: string[] },
    scope: { archCode?: string; cat1?: string },
): FieldGroupEditorState {
    return {
        ...newFieldGroupEditor(scope),
        groupKey: s.groupKey,
        label: s.label,
        src: s.src || '',
        deviceKeys: s.deviceKeys || [],
        cat2Keys: s.cat2Keys || [],
        layout: s.layout || 'flat',
        rowSource: s.rowSource || '',
        rowLabel: s.rowLabel || '',
        fields: parseGroupFields(s.fields),
        fieldLayout: parseLayout(s.fieldLayout),
        isEnabled: s.isEnabled !== false,
    };
}
